import { start } from "./reverse-trial-dialog.js";
void start();
